import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'


const normalizeRole = (user) => {
  if (!user) return null

  const roles = []

  if (user.role) {
    roles.push(String(user.role).trim().toLowerCase())
  }

  if (Array.isArray(user.roles)) {
    user.roles.forEach((item) => {
      if (typeof item === 'string') {
        roles.push(item.trim().toLowerCase())
      } else if (item?.name) {
        roles.push(
          String(item.name).trim().toLowerCase()
        )
      } else if (item?.role) {
        roles.push(
          String(item.role).trim().toLowerCase()
        )
      }
    })
  }

  if (
    roles.includes('administrator') ||
    roles.includes('admin')
  ) {
    return 'Administrator'
  }

  if (roles.includes('om')) {
    return 'OM'
  }

  if (roles.includes('tm')) {
    return 'TM'
  }

  if (roles.includes('staff')) {
    return 'Staff'
  }

  return null
}


const RoleRoute = ({
  children,
  roles = [],
}) => {

  const {
    user,
    loading,
    isAuthenticated,
  } = useAuth()

  const location = useLocation()


  // Auth still loading
  if (loading) {
    return (
      <div
        style={{
          minHeight: '240px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#64748b',
          fontSize: '13px',
        }}
      >
        Loading...
      </div>
    )
  }


  // Not logged in
  if (!isAuthenticated || !user) {
    return (
      <Navigate
        to="/login"
        replace
        state={{
          from: location.pathname,
        }}
      />
    )
  }


  const role = normalizeRole(user)


  // Administrator has full access
  if (role === 'Administrator') {
    return children
  }


  // Check allowed roles
  const allowedRoles =
    Array.isArray(roles)
      ? roles
      : [roles]

  if (allowedRoles.includes(role)) {
    return children
  }


  // No permission
  return (
    <Navigate
      to="/"
      replace
    />
  )
}


export default RoleRoute